import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IResponseOption } from "@interfaces";

import type { IPathBaseParam, IPathByIdParam } from "./path";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption & { city: string }>>,
  IPathBaseParam,
  IPaginationParams
>("test");
const getApis = createGetApi<
  IApiResponse<IResponseOption>,
  IPathByIdParam,
  object
>("test");

export const test = {
  ...getAllApis,
  ...getApis,
};
